<template>
    <div class="row form-group">
        <div class="col-md-12">
            <div class="d-flex justify-content-between">
                <label class="btn btn-sm btn-flat-info btn-outline-info" for="portfoliofile">
                    {{ $t('eventManagement.uploadFile') }}
                </label>
                <input type="file" id="portfoliofile" ref="portfoliofile" style="display:none" multiple
                    @change="onEventFileChange" />
            </div>

            <div class="file-table-container">
                <table style="width:100%">
                    <tr v-for="(eventAttachment, index) in model.attach_file_list" :key="index">
                        <td style="width:40%;">
                            <FileView :resource="eventAttachment" @click="onViewFile(index)" />
                        </td>
                        <td style="width:40%;" class="mt-2" :class="{ 'text-red': eventAttachment.invalid_file }">
                            {{ eventAttachment.name }}
                            <!-- Spinner for uploading -->
                            <span v-if="!eventAttachment.uploaded" class="ml-2 text-info">
                                <i class="fa fa-spinner fa-spin"></i> Uploading...
                            </span>
                        </td>
                        <td class="text-center" style="width:20%;">
                            <a-popconfirm placement="leftTop" :title="$t('are_you_sure_to_delete')" :ok-text="$t('yes')"
                                :cancel-text="$t('no')" @confirm="onRemoveFile(index, eventAttachment)">
                                <a href="#" class="text-red" v-if="eventAttachment.progressing == 100">
                                    <i class="fa fa-times"></i>
                                </a>
                            </a-popconfirm>
                        </td>
                    </tr>
                </table>
            </div>
        </div>

        <!-- Modal -->
        <a-modal v-model="showModalFileView" :zIndex="1020" width="40%" :title="$t('eventManagement.viewAttachment')"
            :footer="null" :maskClosable="false">
            <div class="ts-relative ts-text-center" style="height: 70vh;">
                <button @click.prevent="onMoveBack" class="nav-btn left"><i class="fas fa-chevron-left"></i></button>
                <button @click.prevent="onMoveNext" class="nav-btn right"><i class="fas fa-chevron-right"></i></button>
                <ViewModal :fileResource="currentViewFileResource" />
            </div>
        </a-modal>
    </div>
</template>

<script>
import httpClient from '@/http-client'
import { mapActions } from 'vuex'
import FileView from './components/file-viewer.vue'
import ViewModal from './components/view-modal.vue'

export default {
    name: 'eventAttachFile',
    components: { FileView, ViewModal },
    props: ['value', 'editData'],
    data() {
        return {
            showModalFileView: false,
            currentViewIndex: 0,
            model: {},
        }
    },
    created() {
        this.model = this.value
        this.setEdit()
    },
    computed: {
        isEdit() {
            return !_.isEmpty(this.editData)
        },
        currentViewFileResource() {
            if (this.model) return this.model.attach_file_list[this.currentViewIndex]
            return undefined
        }
    },
    methods: {
        ...mapActions('eventManagement', ['removeFileUploaded']),

        onEventFileChange(e) {
            const files = Array.from(e.target.files)
            if (!this.model.attach_file_list) this.model.attach_file_list = []

            this.$emit('uploading', true) // tell parent uploads started

            const uploadPromises = files.map(file => {
                const ALLOW_FILE = ['image/png', 'image/jpeg', 'application/pdf']
                if (!ALLOW_FILE.includes(file.type)) {
                    this.$toasted.error(`File type not allowed: ${file.name}`)
                    return Promise.resolve()
                }

                const f = {
                    event_att_id: 0,
                    attach_file_path: null,
                    attach_file_name: file.name,
                    name: file.name,
                    type: file.type,
                    progressing: 0,
                    uploaded: false,
                    storage_path: null,
                    file: file
                }
                this.model.attach_file_list.push(f)

                const frm = new FormData()
                frm.append('file', f.file)
                frm.append('file_type', 1)

                return httpClient.post('/api/event-managements/upload-files', frm, {
                    onUploadProgress: el => {
                        if (el.lengthComputable) f.progressing = Math.round((el.loaded * 100) / el.total)
                    }
                }).then(response => {
                    f.uploaded = true
                    f.storage_path = response.data.attach_file_path
                    f.attach_file_path = response.data.attach_file_path
                }).catch(error => {
                    this.$toasted.error(error.message)
                })
            })

            Promise.all(uploadPromises).finally(() => {
                this.$emit('uploading', false) // tell parent uploads done
            })
        },

        onRemoveFile(index, record) {
            if (record.event_att_id > 0) {
                this.removeFileUploaded({
                    event_att_id: record.event_att_id,
                    attach_file_path: record.attach_file_path
                })
            }
            this.model.attach_file_list.splice(index, 1)
        },

        setEdit() {
            if (this.isEdit) {
                this.model.attach_file_list = this.editData.event_attachments.map(el => ({
                    event_att_id: el.event_att_id,
                    name: el.attach_file_name,
                    type: el.attach_file_mime_type,
                    progressing: 100,
                    file: el.attach_file_path,
                    attach_file_path: el.attach_file_path,
                    uploaded: true,
                    storage_path: el.storage_path
                }))
            }
        },

        onViewFile(index) {
            this.showModalFileView = true
            this.currentViewIndex = index
        },
        onMoveBack() {
            this.currentViewIndex =
                this.currentViewIndex - 1 >= 0
                    ? this.currentViewIndex - 1
                    : this.model.attach_file_list.length - 1
        },
        onMoveNext() {
            this.currentViewIndex =
                this.currentViewIndex + 1 < this.model.attach_file_list.length
                    ? this.currentViewIndex + 1
                    : 0
        }
    }
}
</script>

<style scoped>
.file-table-container {
    max-height: calc(5 * 30px);
    overflow-y: auto;
    padding: 2px 0;
}

.nav-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: #e2e2e2;
    padding: 8px 12px;
    border-radius: 6px;
    cursor: pointer;
}

.nav-btn.left {
    left: 10px;
}

.nav-btn.right {
    right: 10px;
}
</style>
